import React from 'react'
import { connectToLocale } from '@insight/toolkit-react'
import { SearchProvider } from './context/SearchContext'
import { RecommendationsProvider } from './context/RecommendationsContext'
import SearchPageWrapper from './components/SearchPageWrapper'

function WrapperComponent({ context, landingPageInfo }) {
  const {
    salesOrg,
    coveoData,
    currencyCode,
    contract,
    isLoggedIn,
    isIPSUser,
    permissions,
    userType,
  } = context || {};

  return (
    <SearchProvider
      salesOrg={salesOrg}
      coveoData={coveoData}
      currencyCode={currencyCode}
      contract={contract}
      isLoggedIn={isLoggedIn}
      isIPSUser={isIPSUser}
      permissions={permissions}
      userType={userType}
    >
      <RecommendationsProvider>
        <SearchPageWrapper landingPageInfo={landingPageInfo} />
      </RecommendationsProvider>
    </SearchProvider>
  );
}

export default connectToLocale(WrapperComponent)